<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-02-27 22:00:34
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-07 18:58:40
 * @Description: file content
 -->
<template>
  <div class="city-sel-layer">
    <div class="left-layer" v-if="isAlej || isHldc">
      <div class="city" @click="goIntro()">{{cityname}}</div>
      <div class="line"></div>
      <div class="search" @click="goProList()">输入搜索的项目</div>
    </div>
    <div v-else class="city2" @click="goIntro()">{{cityname}}</div>
    <div class="btn_map" @click="clickDiTuZhaoFang">    
      <img src="https://assets.rurushishi.com//yq-rs-make/t9/btn_map2.png" alt />
      地图找房
    </div>
    <CityCheck
      :hotlist="hotlist"
      :areaslist="areaslist"
      :cityname="cityname"
      :isShow="isShowCheck"
      v-on:close="closeCityCheck"
    ></CityCheck>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
const CityCheck = () => import("@/components/city_check2");
export default {
  components: {
    CityCheck
  },
  props: {
    id: String
  },
  data() {
    return {
      isAlej: util.checkIsAlej(), //是否安联
      isHldc: util.checkIsHldc(), //是否汇龙地产
      cityname: "",
      hotlist: [],
      areaslist: [],
      isShowCheck: false,
    };
  },
  watch: {},
  computed: {
    ...mapState(["isInMiniProgram", "pageInfo"])
  },
  methods: {
    // lj07
    clickDiTuZhaoFang() {
      let url = `${location.protocol}//${location.host}/h5/t9_map?from=t9`;
      util.openYqRsMakeLink(url);
    },

    goProList() {
      let url = `${location.protocol}//${location.host}/h5/t9_project?from=t9`;
      util.openYqRsMakeLink(url);
    },

    // lj08 
    goIntro() {
      this.isShowCheck = true
      // let url = "";
      // if (util.checkIsHuafaTest()) {
      //   url = `${location.protocol}//qmyx.huafacrm.com/h5/huafa/sysintro?from=t9`;
      // } else {
      //   url = `${location.protocol}//zhhfzygj.huafamarkting.com/h5/huafa/sysintro?from=t9`;
      // }
      // if (this.global.isLoc) {
      //   url = `${location.protocol}//${location.host}/h5/huafa/sysintro?from=t9`;
      // }
      // util.openYqRsMakeLink(url);
    },
    closeCityCheck() {
      this.isShowCheck = false
    }
  },
  created() {},
  mounted() {
    //获取当前城市
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      //获取配置的城市
      comreq.guideConfig(this.id).then(data => {
        let jsonObj = JSON.parse(data.obj.data);
        console.log(jsonObj)
        this.hotlist = jsonObj.hots;
        this.areaslist = jsonObj.areas;
        jsonObj.areas.forEach(item => {
          item.list.forEach(city => {
            if (this.pageInfo.PageId == city.pageid) {
              this.cityname = city.name;
              Cookies.set('hf_cur_city_name', city.name)
            }
          });
        });
        if (!this.cityname) {
          this.cityname = "未获取";
        }
      });
    });
  }
};
</script>
<style lang="css" scoped>
.city-sel-layer {
  line-height: 0.8rem;
  margin: .2rem .3rem .3rem .3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.city-sel-layer .left-layer {
  display: flex;
  align-items: center;
  justify-content: center;  
  background-color: #ffffff;
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 5px;
  padding: 0 .2rem;
}
.city-sel-layer .left-layer .city {
  font-size: 0.26rem;
  color: #333333;
  background: #fff url(https://assets.rurushishi.com//yq-rs-make/t9/btn_arrow.png) no-repeat right .1rem center;
  background-size: 0.24rem 0.24rem;
  padding-right: .4rem;
  /*padding-left: .2rem;*/
}
.city2 {
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 5px;  
  font-size: 0.26rem;
  color: #333333;
  background: #fff url(https://assets.rurushishi.com//yq-rs-make/t9/btn_arrow.png) no-repeat right .1rem center;
  background-size: 0.24rem 0.24rem;
  padding-right: .4rem; 
  padding-left: .2rem; 
}
.city-sel-layer .left-layer .line {
  width: 1px;
  height: .4rem;
  background-color: #999999;
  margin: 0 .2rem;
}

.city-sel-layer .left-layer .search {
  background: url(https://assets.rurushishi.com//yq-rs-make/t9/t9_defalut/sousuo.png) no-repeat left center;
  background-size: 0.3rem 0.3rem;
  padding-left: .4rem;
  font-size: .26rem;
  color: #464646; 
}

.btn_map {
  flex: 1;
  background-color: #ffffff;
  height: 0.8rem;
  line-height: 0.8rem;
  margin-left: .2rem;
  border-radius: 5px;
  text-align: center;
  font-size: .24rem;
}
.btn_map > img {
  height: 0.32rem;
  width: 0.32rem;
  vertical-align: text-top;
}
</style>